import { BridgeMonitor } from './utils'

// 这里为移动端给H5发送的消息
// triggerWebViewLifecycleEvent 为页面展示和隐藏时，端上会发送消息
// 页面重新展现：onResume，页面隐藏：onPause

let triggerWebViewLifecycleEvent = {
  register: () => {},
  unregister: () => {},
  clear: () => {},
}

const initTriggerWebViewLifecycleEvent = () => {
  try {
    triggerWebViewLifecycleEvent = new BridgeMonitor('merchant', 'triggerLifecycle')
  } catch (err) {
    console.log(err)
  }
}

// triggerContractorInfoUpdated 为管理端app主体切换时，端上主动发送最新主体信息给H5
let triggerContractorInfoUpdatedEvent = {
  register: () => {},
  unregister: () => {},
}

const initTriggerContractorInfoUpdatedEvent = () => {
  try {
    triggerContractorInfoUpdatedEvent = new BridgeMonitor(
      'merchant',
      'triggerContractorInfoUpdated',
    )
  } catch (err) {
    console.log(err)
  }
}

const PAGE_STATUS = {
  SHOW: 'onResume',
  HIDE: 'onPause',
}

export {
  PAGE_STATUS,
  initTriggerWebViewLifecycleEvent,
  triggerWebViewLifecycleEvent,
  initTriggerContractorInfoUpdatedEvent,
  triggerContractorInfoUpdatedEvent,
}
